import { SVGProps } from "react";

const IconLogs = (props: SVGProps<SVGSVGElement>) => {
    const { className, ...rest } = props;

    return (
        <svg
            className={className}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            {...rest}
        >
            <path
                d="M14 8.23503V3C14 2.44772 13.5523 2 13 2H3C2.44772 2 2 2.44772 2 3V19C2 19.5523 2.44772 20 3 20H13C13.5523 20 14 19.5523 14 19V18.0327"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <line
                x1="4.75"
                y1="10.25"
                x2="8.25"
                y2="10.25"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <line
                x1="4.75"
                y1="5.75903"
                x2="11.252"
                y2="5.75903"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <line
                x1="4.75"
                y1="13.25"
                x2="7.25"
                y2="13.25"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <line
                x1="4.75"
                y1="16.25"
                x2="8.25"
                y2="16.25"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <circle
                cx="15.121"
                cy="12.6928"
                r="2.24819"
                transform="rotate(-33.812 15.121 12.6928)"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <circle
                cx="15.122"
                cy="12.6929"
                r="4.95762"
                transform="rotate(-33.812 15.122 12.6929)"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path
                d="M18.4142 20.2734C18.7216 20.7323 19.3427 20.8551 19.8016 20.5478L20.2148 20.271C20.6737 19.9637 20.7965 19.3426 20.4892 18.8837L18.8499 16.436L16.7749 17.8257L18.4142 20.2734Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default IconLogs;
